import { render, staticRenderFns } from "./playerView.vue?vue&type=template&id=5c830f8c&scoped=true&"
import script from "./playerView.vue?vue&type=script&lang=js&"
export * from "./playerView.vue?vue&type=script&lang=js&"
import style0 from "./playerView.vue?vue&type=style&index=0&id=5c830f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c830f8c",
  null
  
)

export default component.exports

/* vue-cli-plugin-import-components */
const vueCliInstallComponent = require("!../../node_modules/vue-cli-plugin-import-components/dist/runtime/installComponents.js")
import LessonList from "@/components/player/lessonList.vue";
import NotesEntry from "@/components/notesEntry.vue";
import Player from "@/components/player/Player.vue";
vueCliInstallComponent(component, {LessonList, NotesEntry, Player});